import { SocialLinksEnum } from '@systemeio/digital-store-shared'
import { TLocoType } from 'shared/hooks/use-loco-translation'

export const getSocialLinkPlaceholder = (t: TLocoType, socialLink: SocialLinksEnum): string => {
  switch (socialLink) {
    case SocialLinksEnum.instagram:
    case SocialLinksEnum.tiktok:
    case SocialLinksEnum.twitter:
    case SocialLinksEnum.telegram:
      return t('dashboard.store.social_media.your_username')
    case SocialLinksEnum.youtube:
      return 'youtube.com'
    case SocialLinksEnum.facebook:
      return 'facebook.com'
    case SocialLinksEnum.spotify:
      return 'spotify.com'
    case SocialLinksEnum.linkedin:
      return 'linkedin.com'
    case SocialLinksEnum.pinterest:
      return 'pinterest.com'
    case SocialLinksEnum.snapchat:
      return 'snapchat.com'
    case SocialLinksEnum.twitch:
      return 'twitch.tv'
    case SocialLinksEnum.discord:
      return 'discord.com'
    case SocialLinksEnum.vimeo:
      return 'vimeo.com'
    case SocialLinksEnum.etsy:
      return 'etsy.com'
    case SocialLinksEnum.email:
      return 'email@gmail.com'
    case SocialLinksEnum.website:
      return 'link.com'
    case SocialLinksEnum.whatsapp:
      return t('dashboard.store.social_media.your_phone_number')
    default:
      return ''
  }
}
